export const TIME_FORMAT = 'dd MMMM, yyyy';
export const APP_STORE = 'App Store';
export const GOOGLE_PLAY = 'Google Play';
export const WEB_SITE = 'web site';
export const ANNUAL_PLAN = 'Annual Plan';
export const MONTHLY_PLAN = 'Monthly plan';
export const MONTHLY_PRICE = '$6.99';
export const ANNUAL_PRICE = '$34.99';
export const DAYS_TRIAL = 7;
